import { FC } from "react";
import { SortOrder } from "../../../store/vacancy/types";
import Sort from "../../UI/Icons/Sort";

export type sortFields = "business_name" | "current_jobs_count" | "past_jobs_count" | "last_job_date";

interface ListHeaderProps {
  /** Assuming it's a string like "first_name" */
  selectedSortBy: string;
  /** If sort order is always "asc" or "desc" */
  selectedSortOrder: SortOrder;
  /** Function type with a string parameter */
  handleSortChange: (sortBy: sortFields) => void;
}

const ListHeader: FC<ListHeaderProps> = ({
  selectedSortBy,
  selectedSortOrder,
  handleSortChange
}) => {
  return (
    <>
        <div className="border-bottom border-off-white d-none d-lg-flex gap-20 align-items-center px-15px py-10px  fs-13 fw-700 text-black">
        <div className="min-w-50px"></div>
        <div className="min-w-240px flex-grow-1 d-flex gap-5 align-items-center">
          Centre Name
          <div onClick={() => handleSortChange("business_name")}>
            <Sort
              active={selectedSortBy === "business_name"}
              direction={selectedSortOrder}
            />
          </div>
        </div>
        <div className="min-w-135px d-flex gap-5 align-items-center">
          Current Listings
          <div onClick={() => handleSortChange("current_jobs_count")}>
            <Sort
              active={selectedSortBy === "current_jobs_count"}
              direction={selectedSortOrder}
            />
          </div>
        </div>
        <div className="min-w-120px d-flex gap-5 align-items-center">
          Your Past Jobs
          <div onClick={() => handleSortChange("past_jobs_count")}>
            <Sort
              active={selectedSortBy === "past_jobs_count"}
              direction={selectedSortOrder}
            />
          </div>
        </div>
        <div className="min-w-115px d-flex gap-5 align-items-center">
          Your Last Job
          <div onClick={() => handleSortChange("last_job_date")}>
            <Sort
              active={selectedSortBy === "last_job_date"}
              direction={selectedSortOrder}
            />
          </div>
        </div>
        <div className="min-w-130px"></div>
      </div>
    </>
  );
};

export default ListHeader;
